<template>
  <div id="now-data">
    <!-- <div style="float:left;">
      <i-circle
        :stroke-color="['#ff3350','#fbca60']"
        trail-color="#ddd"
        :percent="(data[curentPoint].speed / 140) * 100"
        dashboard
        :size="70"
      >
        <span class="demo-circle-inner" style="font-size:20px;">{{data[curentPoint].speed}}</span>
        <p style="margin:4px auto 0px auto">km/h</p>
      </i-circle>
    </div> -->
    <!-- <ul style="float:left;margin-left:10px;">
      <li style="margin-bottom:4px;">
        <span>{{data[curentPoint].time}}</span>
      </li>
      <li>
        <span>{{data[curentPoint].address==null?'地址解析失败':data[curentPoint].address}}</span>
      </li>
    </ul> -->
    <Row>
      <Col span="24">{{ data[curentPoint].gpsTime }} </Col>
      <Col span="24"> <slot name="address"></slot></Col>
    </Row>
    <Row>
      <Col span="7"> 速度：{{ data[curentPoint].speed }} </Col>
      <Col span="10"> 里程：{{ data[curentPoint].mileage }} </Col>
      <Col span="7"> ACC：{{ data[curentPoint].acc }} </Col>
    </Row>
    
  </div>
</template>
<script>
export default {
  props: ["data", "curentPoint"],
  data() {
    return {
      deal: false,
    };
  },
  methods: {
    detail() {
      this.$emit("list", (this.deal = !this.deal));
    },
  },
};
</script>
<style lang="">
#now-data {
  background: #fff;
  width: 100%;
  position: absolute;
  top: -20px;
  left: 0;
  z-index: 223;
  padding-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/locus/nowData.vue